<div class="comment-group d-flex flex-column flex-md-row edit-comment" *transloco="let convert;">
  <div class="d-flex flex-column flex-md-row app-textarea form-group mb-0 w-100">
    <label class="text-start comment-label" [for]="commentBoxId">{{ convert('shared.editComment.textComment') }}</label>
    <div class="input-group">
      <form [formGroup]="form" allytm-async>
        <div class="comment-input-container d-flex flex-column">
          <input
            #commentBoxInput
            [attr.id]="commentBoxId"
            class="comment-text-field"
            type="text"
            autocomplete="off"
            [attr.aria-label]="convert('shared.editComment.ariaLabelAddComment')"
            placeholder="{{convert('shared.editComment.placeholderComment')}}"
            formControlName="comment"
            (keyup)="replaceInvalidCharacters($event)"
            (keydown)="commentKeydown($event)"
            name="comment"
            maxlength="150"
            [attr.aria-describedby]="'description-' + commentBoxId"
          />
          <p class="text-end fw-bold edit-comment-indicator" style="font-size: 11px">
            {{ commentLength$ | async }}/150 {{convert('shared.editComment.texCharacter')}}
          </p>
          <div class="visually-hidden" [attr.id]="'description-' + commentBoxId">
            {{convert('shared.editComment.textEnterMaximum')}}
          </div>
          <div class="visually-hidden" aria-live="polite" role="region" aria-atomic="true" aria-label="edit-polite-message">{{ politeMessage$ | async }}</div>
          <div class="visually-hidden" aria-live="assertive" role="region" aria-atomic="true"  aria-label="edit-assertive-message">
            {{ assertiveMessage$ | async }}
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="input-group-append d-flex flex-column flex-md-row">
    <button
      class="btn btn-primary"
      type="button"
      allytmln="Manage Inventory Comment"
      (click)="updateComment()"
      data-track-elem="button"
      data-track-name="Save Comment"
      aria-label="Save comment"
      [id]="'vehicle_comments_edit_save_button_' + index"
    >
    {{convert('common.btnSave')}}
    </button>
    <button
      class="btn btn-link focus-outline"
      type="button"
      (click)="cancel()"
      data-track-elem="button"
      data-track-name="Cancel"
      aria-label="Cancel editing comment"
      data-track-trigger="close"
      [id]="'vehicle_comments_edit_cancel_button_' + index"
    >
    {{convert('common.btnCancel')}}
    </button>
  </div>
</div>
